import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogModule } from '@features/dialog/dialog.module';
import { CategoryNavigationComponent } from '@features/product-filter/category-navigation/category-navigation.component';
import { FacetTagsComponent } from '@features/product-filter/facet-tags/facet-tags.component';
import { FilterCountComponent } from '@features/product-filter/filter-count/filter-count.component';
import { FilterFacetsComponent } from '@features/product-filter/filter-facets/filter-facets.component';
import { FilterSelectComponent } from '@features/product-filter/filter-select/filter-select.component';
import { LoadMoreComponent } from '@features/product-filter/load-more/load-more.component';
import { MobileFilterComponent } from '@features/product-filter/mobile-filter/mobile-filter.component';
import { ActiveFacetsCountPipe } from '@features/product-filter/pipes/active-facets-count.pipe';
import { ActiveFacetsNamesPipe } from '@features/product-filter/pipes/active-facets-names.pipe';
import { FacetGroupsWithValuesPipe } from '@features/product-filter/pipes/facet-groups-with-values.pipe';
import { GetGroupPrefixPipe } from '@features/product-filter/pipes/get-group-prefix.pipe';
import { HasActiveFacetsPipe } from '@features/product-filter/pipes/has-active-facets.pipe';
import { ReplaceKeyPipe } from '@features/product-filter/pipes/replace-key.pipe';
import { ToFacetExposedCollectionPipe } from '@features/product-filter/pipes/to-facet-exposed-collection.pipe';
import { SortingComponent } from '@features/product-filter/sorting/sorting.component';
import { ProductModule } from '@features/product/product.module';
import { StoreStockModule } from '@features/store-stock/store-stock.module';
import { SharedModule } from '@shared/shared.module';

import { GetSearchParamPipe } from './pipes/get-search-param.pipe';
import { ProductFilterComponent } from './product-filter/product-filter.component';
import { StoreStockFacetComponent } from './store-stock-facet/store-stock-facet.component';
import { ResultCountComponent } from './result-count/result-count.component';
import { SameDayDeliveryFacetComponent } from './same-day-delivery-facet/same-day-delivery-facet.component';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SameDayDeliveryModule } from '@shared/same-day-delivery/same-day-delivery.module';
import { ReserveInStoreModule } from '@features/reserve-in-store/reserve-in-store.module';
import { GetUspCardPipe } from './pipes/get-usp-card.pipe';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ProductModule,
        RouterModule,
        DialogModule,
        StoreStockModule,
        ReserveInStoreModule,
        FormElementsModule,
        SameDayDeliveryModule,
        CategoryNavigationComponent,
        FacetGroupsWithValuesPipe,
        FacetTagsComponent,
        FilterFacetsComponent,
        FilterSelectComponent,
        HasActiveFacetsPipe,
        LoadMoreComponent,
        MobileFilterComponent,
        ProductFilterComponent,
        SortingComponent,
        ActiveFacetsNamesPipe,
        ActiveFacetsCountPipe,
        ToFacetExposedCollectionPipe,
        FilterCountComponent,
        ReplaceKeyPipe,
        GetGroupPrefixPipe,
        StoreStockFacetComponent,
        GetSearchParamPipe,
        ResultCountComponent,
        SameDayDeliveryFacetComponent,
        GetUspCardPipe
    ],
    exports: [ProductFilterComponent, StoreStockFacetComponent]
})
export class ProductFilterModule {}
